import { createContext, Dispatch, FormEvent, SetStateAction, useContext } from 'react';
import { SurgerieQueryParams } from './useFetchSurgeries';
import { Surgerie } from 'types/surgerie';

export interface SurgerieContextValue {
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  filter: SurgerieQueryParams;
  handleChangeFilter(index: keyof SurgerieQueryParams, value: any): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
  selectedSurgerie: Surgerie | null;
  setSelectedSurgerie: Dispatch<React.SetStateAction<Surgerie | null>>;
  setCloseSurgerie: Dispatch<SetStateAction<boolean>>;
}

const SurgerieContext = createContext<SurgerieContextValue>({} as SurgerieContextValue);
export const SurgerieProvider = SurgerieContext.Provider;
export const SurgerieConsumer = SurgerieContext.Consumer;

export function useSurgerie(): SurgerieContextValue {
  const context = useContext(SurgerieContext);
  return context;
}
